import { Component } from "react";
export default class MatchingFieldHighLight extends Component {
  constructor(props) {
    super(props);
  }

  highlightInflectionWords(text, inflectionWordList) {
    let result = text;
    // eslint-disable-next-line no-useless-escape
    result = result.replace(/['".*+?^${}()|\[\]\\,-]/g, " ").replace(/\s+/g, " ");
    // Iterate through each inflection word in the inflectionWordList
    inflectionWordList.forEach((wordData) => {
      let word = wordData.split(" "); // Split the inflection word and ID
      word.forEach((words) => {
        if (words.length > 1) {
          // eslint-disable-next-line no-useless-escape
          let regex = new RegExp(`\\b${words.replace(/['".*+?^${}()|\[\]\\,\s-]/g, "\\$&").replace(/\s+/g, "\\$&")}\\b`, "gi"); // Create a regex to match the words globally and case-insensitively
          result = result.replace(regex, `<span style="background-color: #fec84b; color: #101828; padding: 2px;" >${words.toUpperCase()}</span>`);
        } // Replace the word with highlighted version
      });
    });
    return result; // Return the text with inflection words highlighted
  }

  highlightInflectionWordsInMatchedData(matchedData, inflectionWordList) {
    let result = "";
    for (let i = 0; i < matchedData.length; i++) {
      let count = matchedData[i].key;
      let highlightedCount = this.highlightInflectionWords(count, inflectionWordList);
      if (highlightedCount !== count) {
        if (i === matchedData.length - 1) {
          result += `<div className='matching-field-parent' style="padding-top: 8px;">${matchedData[i].label}<div className='matching-field-child' style="padding-bottom: 12px; padding-top: 12px;">${highlightedCount}</div></div>`;
        } else {
          result += `<div className='matching-field-parent' style="border-bottom: 1px solid #334053; padding-top: 8px;">${matchedData[i].label}<div className='matching-field-child' style="padding-bottom: 12px; padding-top: 12px;">${highlightedCount}</div></div>`;
        }
      }
    }

    return result;
  }

  _getTextWithHighlights(matchedData, searchedtextcontent, inflectionWordList = []) {
    // matchedData is array of objects coming from BE with label and key
    // searchedtextcontent is array of string where array elemments are combination of searched text, semantic search, and words
    let result = "";
    // Check if any inflection words are found
    let inflectionResult = this.highlightInflectionWordsInMatchedData(matchedData, inflectionWordList);
    // If inflection words are found, return the result directly
    if (inflectionResult !== "") {
      return <span dangerouslySetInnerHTML={{ __html: inflectionResult }} />;
    }
    for (let i = 0; i < matchedData.length; i++) {
      // iterating over all the matched object to highlight one word from every object key
      let count = matchedData[i].key.replace(/[^a-zA-Z0-9]/g, " ").replace(/\s+/g, " ");
      for (let k = 0; k < searchedtextcontent.length; k++) {
        if (typeof searchedtextcontent[k] === "string") {
          let flag = true;
          let countCopy = count.toUpperCase();
          let highlight = "";
          let item = searchedtextcontent[k]
            .replace(/[^a-zA-Z0-9]/g, " ")
            .replace(/\s+/g, " ")
            .trim()
            .split(" ");
          for (let j = 0; j < item.length; j++) {
            flag = true;
            highlight = "";
            if (count.split(" ").includes(item[j]) || count.toLowerCase().split(" ").includes(item[j].toLowerCase()) || count.toUpperCase().split(" ").includes(item[j].toUpperCase())) {
              highlight = `<span style="background-color: #fec84b; color: #101828; padding: 2px;" >${item[j].toUpperCase()}</span>`;
            } else {
              flag = false;
              break;
            }
            if (flag) {
              let countArr = countCopy.split(" ");
              let index = countArr.indexOf(item[j].toUpperCase());
              countArr[index] = highlight;
              countCopy = countArr.join(" ");
            }
            highlight = "";
          }
          if (flag) {
            count = countCopy;
            break;
          }
        }
      }
      if (i === matchedData.length - 1) {
        result += `<div className='matching-field-parent' style="padding-top: 8px;">${matchedData[i].label}<div className='matching-field-child' style="padding-bottom: 12px; padding-top: 12px;">${count}</div></div>`;
      } else {
        result += `<div className='matching-field-parent' style="border-bottom: 1px solid #334053; padding-top: 8px;">${matchedData[i].label}<div className='matching-field-child' style="padding-bottom: 12px; padding-top: 12px;">${count}</div></div>`;
      }
    }
    return <span dangerouslySetInnerHTML={{ __html: result }} />;
  }

  render() {
    const { cite } = this.props;
    const textToShow = this._getTextWithHighlights(!!this.props && !!this.props.matchedData && this.props.matchedData !== "" ? this.props.matchedData : "", !!this.props && !!this.props.searchedtextcontent && this.props.searchedtextcontent !== "" ? this.props.searchedtextcontent : "", this.props.inflectionWordList);
    return <span cite={cite}>{textToShow}</span>;
  }
}
